import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button';

function GSFNButton({ onClick }) {
  return (
    <ButtonWithIcon
      data-e2e="insert-structure-from-name"
      type="tertiary"
      sprite="ChevronRight"
      iconRight
      onClick={onClick}
      className="e2e-insert-structure-from-name">
      Insert structure from name
    </ButtonWithIcon>
  );
}

export default GSFNButton;
